import Login from "@/views/Public/Auth/Login";
import Page404 from "@/views/Public/page-404"

const routes = [

  {
    path: '/login',
    name: 'public-auth-login',
    component: Login
  },
  {
    path: '/',
    name: 'public-auth-login',
    component: Login
  },
  // {
  //   path: '/*',
  //   component: Page404
  // }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/routes/public/auth.js